import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';

import { FullReloadService } from '@frontend/sports/common/core/feature/full-reload';
import { UserService } from '@frontend/sports/user/feature';
import { tap } from 'rxjs';

const HTTP_UNAUTHENTICATED = 401;
const HTTP_UNAUTHORIZED = 403;

export const sessionExpirationInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);

    return next(req).pipe(
        tap({
            error: (error: unknown) => {
                if (error instanceof HttpErrorResponse) {
                    responseError(error, injector);
                }
            },
        }),
    );
};

function responseError(error: HttpErrorResponse, injector: Injector): HttpErrorResponse | undefined {
    const user = injector.get(UserService);
    if (!user.isAuthenticated) {
        return error;
    }

    if (error.status === HTTP_UNAUTHENTICATED || error.status === HTTP_UNAUTHORIZED) {
        const fullReloadService = injector.get(FullReloadService);
        fullReloadService.setFullReloadRequired();
    }

    return undefined;
}
